import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { MagicAiComponent } from './magic-ai.component';
import { LandingSharedModule } from '../landing-shared/landing-shared.module';
import { CardSectionComponent } from './cards/cards.component';

@NgModule({
  declarations: [
    MagicAiComponent,
    CardSectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    LandingSharedModule,
  ],
  providers: [],
})
export class MagicAiModule {}
